import { render, staticRenderFns } from "./ReadPaper.vue?vue&type=template&id=5b1dee4b&scoped=true&"
import script from "./ReadPaper.vue?vue&type=script&lang=js&"
export * from "./ReadPaper.vue?vue&type=script&lang=js&"
import style0 from "./ReadPaper.vue?vue&type=style&index=0&id=5b1dee4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1dee4b",
  null
  
)

export default component.exports